import { render, staticRenderFns } from "./setnewPayPassword.vue?vue&type=template&id=3f9cf09a&scoped=true&"
import script from "./setnewPayPassword.vue?vue&type=script&lang=js&"
export * from "./setnewPayPassword.vue?vue&type=script&lang=js&"
import style0 from "./setnewPayPassword.vue?vue&type=style&index=0&id=3f9cf09a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9cf09a",
  null
  
)

export default component.exports